<template>
  <j-modal
    :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
    :title="title"
    :visible="visible"
    :width="width"
    @cancel="handleCancel"
    cancelText="关闭"
    switchFullscreen
  >
    <div class="app-container">
      <div v-if="isLoadingStatus" />
      <div v-else>
        <a-card class="box-card" style="margin-top: 15px">
          <div class="clearfix" slot="title">
            <span>公共信息</span>
          </div>
          <div class="text item">
            <a-form layout="inline">
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="设备名称:" style="margin-bottom: 5px">
                    <span>{{ defRegister.devName }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="设备类型:" style="margin-bottom: 5px">
                    <span>{{ defRegister.devClassCode_dictText }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="缺陷部位类别:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defStandardName }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="缺陷等级:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defLevel_dictText }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="缺陷内容:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defContent }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="缺陷发现时间:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defFindTime }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="联系电话:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defTelephone }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="缺陷发现人:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defInventor_dictText }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="缺陷处理人:" style="margin-bottom: 5px">
                    <span>{{ defRegister.defHandle_dictText }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="缺陷图片:" style="margin-bottom: 5px">
                    <j-image-upload bizPath="scott/pic" class="pt-20px" disabled v-model="defRegisterFileList"></j-image-upload>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <a-row>
                <a-col :span="24">
                  <a-form-model-item label="缺陷视频:" style="margin-bottom: 5px">
                    <a-upload
                      :file-list="defRegister.defVideo"
                      @change="handleChange1"
                      @preview="videoPreview"
                      disabled
                      listType="picture-card"
                    ></a-upload>
                    <!-- <a-modal :footer="null" :visible="videoPreviewVisible" @cancel="handleCancel1">
                                            <video width="100%" height="100%" controls="controls" id="video">
                                                您的浏览器不支持播放该视频！
                                            </video>
                    </a-modal>-->
                    <j-modal
                      :footer="null"
                      :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
                      :visible="videoPreviewVisible"
                      :width="600"
                      @cancel="handleCancel1"
                      cancelText="关闭"
                      switchFullscreen
                      title="缺陷视频"
                    >
                      <video autoplay controls="controls" id="video" width="100%">您的浏览器不支持播放该视频！</video>
                    </j-modal>
                  </a-form-model-item>
                </a-col>
              </a-row>
            </a-form>
          </div>
        </a-card>
        <a-card class="box-card" style="margin-top: 15px;">
          <div class="clearfix" slot="title">
            <span>事件基本信息</span>
          </div>
          <div class="text item">
            <a-form layout="inline">
              <a-row>
                <a-col :span="12">
                  <a-form-model-item label="是否结束:" style="margin-bottom: 5px">
                    <span>{{ evntProcessInfo.isEndName }}</span>
                  </a-form-model-item>
                </a-col>
                <a-col :span="12">
                  <a-form-model-item label="指定处理人:" style="margin-bottom: 5px">
                    <span>{{ evntProcessInfo.processorName }}</span>
                  </a-form-model-item>
                </a-col>
              </a-row>
              <!-- <a-row>
                                <a-col :span="12">
                                    <a-form-model-item label="催办次数:" style="margin-bottom: 5px">
                                        <span>{{ evntProcessInfo.urgeCount }}</span>
                                    </a-form-model-item>
                                </a-col>
                                <a-col :span="12">
                                    <a-form-model-item label="上一次催促时间:" style="margin-bottom: 5px">
                                        <span>{{ evntProcessInfo.urgeLastTime }}</span>
                                    </a-form-model-item>
                                </a-col>
              </a-row>-->
              <!--  <a-row>
                            <a-col :span="12">
                                <a-form-model-item label="备注:" style="margin-bottom: 5px">
                                    <span>{{ evntProcessInfo.remarks }}</span>
                                </a-form-model-item>
                            </a-col>
              </a-row>-->
            </a-form>
          </div>
        </a-card>

        <a-card class="box-card" style="margin-top: 15px;">
          <div class="clearfix" slot="title">
            <span>备件消耗</span>
          </div>
          <div class="text item">
            <!-- 消耗得备品备件列表 -->
            <DevBpbjLeadoutRecordList :canEdit="false" :showTitle="false" ref="devBpbjLeadoutRecordList"></DevBpbjLeadoutRecordList>
          </div>
        </a-card>
        <a-card class="box-card" style="margin-top: 15px">
          <div class="clearfix" slot="title">
            <span>事件流转历史</span>
          </div>
          <a-row>
            <a-col :span="12">
              <div class="text item">
                <a-steps
                  direction="vertical"
                  progress-dot
                  v-if="evntProcessCirculationHistoryList !== undefined && evntProcessCirculationHistoryList !== null && evntProcessCirculationHistoryList !== ''"
                  v-model:current="activeIndex"
                >
                  <template v-for="(item, index) in evntProcessCirculationHistoryList">
                    <a-step :disabled="true">
                      <a @click="stepsChange(item,index)" slot="title">
                        <span>{{item.handleTime}}</span>
                      </a>
                      <span slot="description">
                        {{item.processorName}} &nbsp;&nbsp;
                        <span v-if="item.status==1">
                          <a-tag color="#52c41a" disabled>{{item.statusName}}</a-tag>
                        </span>
                        <span v-if="item.status==2">
                          <a-tag color="#faad14" disabled>{{item.statusName}}</a-tag>
                        </span>
                        <span v-else-if="item.status==3">
                          <a-tag color="#ff4d4f" disabled>{{item.statusName}}</a-tag>
                        </span>
                        <span v-else-if="item.status==4">
                          <a-tag color="purple" disabled>{{item.statusName}}</a-tag>
                        </span>
                      </span>
                    </a-step>
                  </template>
                </a-steps>
                <div v-else>
                  <a-alert message="未找到当前事件流程信息。" show-icon type="warning" />
                </div>
              </div>
            </a-col>
            <a-col :span="12">
              <div class="text item">
                <a-form>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item :label="descriptionLabel">
                        <span>{{ formData.description }}</span>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="关联图片" prop="formDataFileList">
                        <j-image-upload bizPath="scott/pic" class="pt-20px" disabled v-model="formDataFileList"></j-image-upload>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                  <a-row>
                    <a-col :span="24">
                      <a-form-model-item label="关联视频">
                        <a-upload
                          :file-list="formDataVideoFileList"
                          @preview="videoPreview1"
                          disabled
                          listType="picture-card"
                        ></a-upload>
                        <!-- <a-modal :footer="null" :visible="videoPreviewVisible1" @cancel="handleCancel2">
                          <video controls="controls" height="100%" id="video1" width="100%">您的浏览器不支持播放该视频！</video>
                        </a-modal>-->
                        <j-modal
                          :footer="null"
                          :okButtonProps="{ class:{'jee-hidden': disableSubmit} }"
                          :visible="videoPreviewVisible1"
                          :width="600"
                          @cancel="handleCancel2"
                          cancelText="关闭"
                          switchFullscreen
                          title="缺陷视频"
                        >
                          <video autoplay controls="controls" id="video1" width="100%">您的浏览器不支持播放该视频！</video>
                        </j-modal>
                      </a-form-model-item>
                    </a-col>
                  </a-row>
                </a-form>
              </div>
            </a-col>
          </a-row>
        </a-card>
      </div>
    </div>
  </j-modal>
</template>

<script>
  import { postAction } from '@/api/manage'
  import { validatenull, validatenotnull } from '@/utils/validate'
  import { mapGetters } from 'vuex'
  import DevBpbjLeadoutRecordList from '@/views/eMaintenance/modules/DevBpbjLeadoutRecordList'

  export default {
    //缺陷处理历史
    name: 'DefHandleList',
    components: {
      DevBpbjLeadoutRecordList,
    },
    data () {
      return {
        title: "消缺记录",
        width: 1096,
        visible: false,
        disableSubmit: true,
        isLoadingStatus: true,
        evntProcessCirculationHistoryList: [],
        evntProcessInfo: {},
        activeIndex: 0,
        defRegister: {},
        defRegisterFileList: [],
        formData: {},
        formDataFileList: [],
        formDataVideoFileList: [],
        url: {
          getEvntCirculationHistoryURL: '/device/defRegister/getEvntCirculationHistory',
        },
        videoPreviewVisible: false,
        previewVideo: '',
        videoPreviewVisible1: false,
        previewVideo1: '',
        descriptionLabel: '',
      }
    },
    watch: {
      //预览并播放视频时,如果关闭了弹框,电脑还有视频的声音,监听视频预览的弹框的打开/关闭,如果关闭了弹框就让video不要播放了
      videoPreviewVisible: function (val) {
        if (val === false) {
          const video = document.getElementById('video')
          video.pause()
        }
      },
      //预览并播放视频时,如果关闭了弹框,电脑还有视频的声音,监听视频预览的弹框的打开/关闭,如果关闭了弹框就让video不要播放了
      videoPreviewVisible1: function (val) {
        if (val === false) {
          const video1 = document.getElementById('video1')
          video1.pause()
        }
      }
    },
    computed: {},
    created () { },
    methods: {
      init (id) {
        this.visible = true
        this.$nextTick(() => {
          this.getEvntCirculationHistoryList(id)
        })
      },
      getEvntCirculationHistoryList (id) {
        postAction(this.url.getEvntCirculationHistoryURL, { id: id }).then((res) => {
          if (res.success) {
            this.defRegister = validatenotnull(res.result.records) ? res.result.records[0] : res.result.records
            if (this.defRegister && validatenotnull(this.defRegister.defPicture)) {
              this.defRegisterFileList = this.defRegister.defPicture.map(item => {
                return item.url
              })
            }
            this.evntProcessCirculationHistoryList = this.defRegister.evntProcessCirculationHistoryList
            if (validatenotnull(this.evntProcessCirculationHistoryList)) {
              this.stepsChange(this.evntProcessCirculationHistoryList[0], 0)
            }
            this.evntProcessInfo = this.defRegister.evntProcessInfo
            this.isLoadingStatus = false
          } else {
            this.$message.warning(res.message)
          }
        }).finally(() => {
          // 调用 消耗备品备件列表数据
          this.$refs.devBpbjLeadoutRecordList.getData(this.defRegister.id)
        })
      },
      stepsChange: function (item, index) {
        this.activeIndex = index
        this.descriptionLabel = item.statusName
        if (item && validatenotnull(item.formData)) {
          this.formData = item.formData
          this.formDataFileList = this.formData.picture.map(item => {
            return item.url
          })
          this.formDataVideoFileList = this.formData.video
        } else {
          this.formData.description = '无'
          this.formDataFileList = []
          this.formDataVideoFileList = []
        }
      },
      handleCancel () {
        this.close()
      },
      close () {
        this.visible = false;
      },
      handleCancel1 () {
        this.videoPreviewVisible = false
      },
      handleCancel2 () {
        this.videoPreviewVisible1 = false
      },
      handleChange1 (info) {
        if (info.file.status === 'done') {
          if (info.file.response.success) {
            this.$message.success(`${info.file.name} 上传成功!`);
          } else {
            this.$message.error(`${info.file.response.message}`);
          }
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.response.message}`);
        }
        if (validatenotnull(info.fileList)) {
          this.model.defVideo = info.fileList.map(item => {
            return {
              uid: item.uid,
              name: item.name,
              status: item.status,
              url: (validatenotnull(item.response) && validatenotnull(item.response.message)) ? item.response.message : '',
            }
          })
          // console.error(this.model.defVideo)
          // console.error(info.fileList)
        }
      },
      beforeUpload1 (file) {
        const isVideo = file.type === 'video/mp4' || file.type === 'video/ogg' || file.type === 'video/webm';
        if (!isVideo) {
          this.$message.error('You can only upload video file!');
        }
        const isLt100M = file.size / 1024 / 1024 < 100;
        if (!isLt100M) {
          this.$message.error('Image must smaller than 100MB!');
        }
        return isVideo && isLt100M;
      },
      videoPreview (file) {
        //预览视频的方法
        this.videoPreviewVisible = true;
        this.$nextTick(() => { //这里一定要使用nextTick,否则document将找不到id为video的节点,因为modal框初始为隐藏状态,<video id='video'>标签初始在dom树中并不存在
          const video = document.getElementById('video')
          video.src = file.url
        })
      },
      videoPreview1 (file) {
        //预览视频的方法
        this.videoPreviewVisible1 = true;
        this.$nextTick(() => { //这里一定要使用nextTick,否则document将找不到id为video的节点,因为modal框初始为隐藏状态,<video id='video'>标签初始在dom树中并不存在
          const video = document.getElementById('video1')
          video.src = file.url
        })
      },
    }
  }
</script>


<style lang="less" scoped>
  /deep/ .ant-steps-item-content {
    width: 300px;
  }
</style>